import React from "react";
import { Typography } from "antd";
import ZipImporter from "../../../component/ZipImporter";

const { Title, Text } = Typography;

export default function ImportPage() {
    return (
        <div>
            <div className="mb-6">
                <Title level={3} className="!mb-1 !text-gray-800">📦 Nhập nội dung hàng loạt</Title>
                <Text type="secondary">Tải 1 file ZIP chứa nhiều Topic / Course / Lesson để tạo nhanh</Text>
            </div>
            <ZipImporter />
        </div>
    );
}
